import React, {useEffect, useState} from "react"
import PropTypes from 'prop-types'
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Button,
  Alert,
  Spinner
} from "reactstrap"
import { useSelector, useDispatch } from "react-redux"
import { getAllHSNs as onGetAllHSNs } from "store/products/actions"

import { editItemDirect as onEditItemDirect } from "helpers/backend_helper"
import { addNewItemDirect as onAddItemDirect } from "helpers/backend_helper"
import { showSuccessToast } from "helpers/function_helper"

const AddNewHSN = props => {
  const dispatch = useDispatch()

  const [validation, setValidation] = useState({
    hsnCode: null,
  })
  const [hsnCode, setHsnCode] = useState('')
  const [hsnDescription, setHsnDescription] = useState('')
  const [showLoading, setShowLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    setTimeout(() => {
      document.getElementById('inp-hsn-code').focus();
      document.getElementById('inp-hsn-code').select();
    }, 250);
    
    if(props.enteredText != ''){
      setHsnCode(props.enteredText)
    }
  }, [props.enteredText])

  useEffect(() => {
    if(props.isEdit){
      //console.log('props.detailsForEdit:'+JSON.stringify(props.detailsForEdit))
      setHsnCode(props.detailsForEdit.code)
      setHsnDescription(props.detailsForEdit.details)
    }
  }, [props.detailsForEdit])

  const onChangeValidation = (fieldName, value) => {
    const modifiedV = { ...validation }
    if (value !== "") {
      modifiedV[fieldName] = true
    } else {
      modifiedV[fieldName] = false
    }
    setValidation(modifiedV)
  }

  function validateForm() {
    const modifiedV = { ...validation }
    let formValid = true;
    if(hsnCode && hsnCode != ""){
      modifiedV["hsnCode"] = true
    }
    else{
      modifiedV["hsnCode"] = false
      formValid = false
    }
    setValidation(modifiedV)
    return formValid
  }

  async function addItem() {
    const formValid = validateForm()

    if(formValid){
      setShowLoading(true)
      const response = await onAddItemDirect({
        'inputKey': hsnCode,
        'inputValue' : hsnDescription
      }, 'HSN')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllHSNs(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Added Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  async function editItem() {
    const formValid = validateForm();
    if(formValid){
      setShowLoading(true)
      const response = await onEditItemDirect({
          'value': props.detailsForEdit.value,
          'code': hsnCode,
          'details' : hsnDescription
        }, 'HSN')

      setShowLoading(false)

      if(response.status == 'success'){
        dispatch(onGetAllHSNs(false))
        props.newlyAddedValue(response.confirmation_code)
        showSuccessToast('Edited Successfully!!!')
      }
      else if(response.status == 'failure'){
        setErrorMessage(response.errorResponse)
      }
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="wizard clearfix">
                    <Form>
                      {errorMessage !== '' ? <Alert color="danger">{errorMessage}</Alert> : null}
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inp-hsn-code">
                              HSN Code
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inp-hsn-code"
                              maxLength="20"
                              value={hsnCode}
                              onChange={event => {
                                onChangeValidation("hsnCode", event.target.value.trim())
                                setHsnCode(event.target.value)
                              }}
                              invalid={
                                validation["hsnCode"] !== true &&
                                validation["hsnCode"] !== null
                              }
                            />
                            {(validation["hsnCode"] === false) &&
                              <div className="custom-error">
                                Please enter the HSN Code
                              </div>
                            }
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="mb-3">
                            <Label for="inpname">
                              HSN Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="inpname"
                              maxLength="500"
                              value={hsnDescription}
                              onChange={event => {
                                onChangeValidation("hsnDescription", event.target.value.trim())
                                setHsnDescription(event.target.value)
                              }}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <div className="d-inline-block float-end">
                            {showLoading && <Spinner style={{ width: '2.2rem', height: '2.2rem' }} className="me-3 mt-3" color="primary" />}
                            {props.isEdit === true ? 
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                editItem()
                              }}
                              disabled={showLoading}
                              >
                                EDIT
                            </Button>
                            :
                            <Button
                              color="info"
                              className="btn w-lg mt-3 float-end btn-info "
                              onClick={() => {
                                addItem()
                              }}
                              disabled={showLoading}
                              >
                                ADD
                            </Button>
                            }
                            </div>
                        </Col>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

AddNewHSN.propTypes = {
  newlyAddedValue: PropTypes.func,
  detailsForEdit: PropTypes.any,
  isEdit:PropTypes.bool,
  enteredText:PropTypes.any,
}

export default AddNewHSN
